import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const DrawerContext = createContext(null);

/* Shared slide-over drawer — ported from the sample UI's #scrim/#drawer.
   Unlike the original (raw innerHTML + manual form.requestSubmit() wiring),
   `content` is a real React node: each call site's drawer content is a
   small component that renders its own form and action buttons, so no
   imperative DOM plumbing is needed to submit it. */
export function DrawerProvider({ children }) {
  const [drawer, setDrawer] = useState(null);

  const openDrawer = useCallback((title, subtitle, content) => {
    setDrawer({ title, subtitle, content });
  }, []);
  const closeDrawer = useCallback(() => setDrawer(null), []);

  useEffect(() => {
    if (!drawer) return;
    const onKey = (e) => { if (e.key === 'Escape') closeDrawer(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [drawer, closeDrawer]);

  return (
    <DrawerContext.Provider value={{ drawer, openDrawer, closeDrawer }}>
      {children}
      <div className={'scrim' + (drawer ? ' open' : '')} onClick={closeDrawer} />
      <aside className={'drawer' + (drawer ? ' open' : '')} role="dialog" aria-modal="true" aria-label="Detail panel">
        {drawer && (
          <>
            <div className="dh">
              <div>
                <div className="eyebrow">{drawer.subtitle}</div>
                <h3>{drawer.title}</h3>
              </div>
              <button className="x" onClick={closeDrawer} aria-label="Close">&times;</button>
            </div>
            <div className="db">{drawer.content}</div>
          </>
        )}
      </aside>
    </DrawerContext.Provider>
  );
}

export function useDrawer() {
  const ctx = useContext(DrawerContext);
  if (!ctx) throw new Error('useDrawer must be used within a DrawerProvider');
  return ctx;
}
